import { ActionType, createAction } from 'typesafe-actions'

import { Investigation, ProductItems } from './types'

export const ImportCheckProductsActions = {
  fetchData: createAction('IMPORT-CHECK-PRODUCTS/load-data')<{
    importId?: string
    page: number
    pageSize: number
  }>(),
  setData: createAction('IMPORT-CHECK-PRODUCTS/set-data')<{
    page: number
    totalPages: number
    data: ProductItems
  }>(),
  setEnabled: createAction('IMPORT-CHECK-PRODUCTS/set-enabled')<{
    itemId: string
    enabled: boolean
  }>(),
  setAllEnabled: createAction('IMPORT-CHECK-PRODUCTS/set-all-enabled')<{
    enabled: boolean
  }>(),
  selectReport: createAction('IMPORT-CHECK-PRODUCTS/select-report')<{
    itemId: string
    companyIdentifier?: string
    reportCode: string
  }>(),
  selectDeliveryOption: createAction('IMPORT-CHECK-PRODUCTS/select-delivery-option')<{
    itemId: string
    companyIdentifier?: string
    reportCode: string
    deliveryOptionCode: string
  }>(),
  selectReportLanguage: createAction('IMPORT-CHECK-PRODUCTS/select-report-language')<{
    itemId: string
    companyIdentifier?: string
    reportCode: string
    reportLanguageCode: string
  }>(),
  setInvestigation: createAction('IMPORT-CHECK-PRODUCTS/set-investigation')<{
    itemId: string
    investigation: Investigation
  }>()
}

export type ImportCheckProductsActions = ActionType<typeof ImportCheckProductsActions>
